<template>
  <div class="card licenses">

    <div class="card-body">

      <h3 class="card-title" v-text="title" />

      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="license of licenses" :key="license.id">
          <span>{{ license.displayName }}</span>
          <license-info :info="license.description" />
        </li>
      </ul>

    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import LicenseInfo from '@/components/ui/LicenseInfo.vue';
import { LicenseData, OrganizationDetails } from '@/components/backend';

export default defineComponent({
  name: 'LicensesCard',
  components: { LicenseInfo },
  emits: ['orgModalClosed'],

  props: {
    title: { type: String, default: '' },
    licenses: { type: Array as PropType<LicenseData[]>, default: new Array<LicenseData>() },
  },

  data: () => ({
    organization: {} as OrganizationDetails,
    state: 'INI' as 'INI' | 'LOAD' | 'RDY' | 'ERR',
  }),

  methods: {},

  computed: {},

  mounted() {
  },
});
</script>

<style scoped>

.card.licenses {
  --bs-card-spacer-x: 1.5rem;
  --bs-card-spacer-y: 1.5rem;
  --bs-card-bg: var(--grey-light);
  --bs-card-border-width: 0;

  --stihl-licenses-max-height: 30rem;

  height: 100%;
}

.card.licenses h3.card-title {
  border-bottom: 1px solid #8D8D8D;
  padding-bottom: 0.75rem;
  --bs-card-title-spacer-y: .75rem;

  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;
}

.card.licenses .list-group {
  --bs-list-group-item-padding-x: 0;
  --bs-list-group-item-padding-y: .85rem;
  --bs-list-group-border-width: 0;

  --bs-list-group-color: var(--grey-deep);
  --bs-list-group-bg: var(--grey-light);

  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 0.875rem;
  line-height: 1rem;

  max-height: var(--stihl-licenses-max-height);
  overflow: auto;
}

.card.licenses .list-group-item {
  display: flex;
  gap: 0.5rem;
}

.card.licenses .list-group-item i img {
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
}

</style>
